import Contacto from './components/Contacto';

function App() {
  return (
    <div className="App">
      <Contacto/>
    </div>
  );
}

export default App;
